import { render } from "./ent_investigations.vue?vue&type=template&id=754dc600&scoped=true"
import script from "./ent_investigations.vue?vue&type=script&lang=js"
export * from "./ent_investigations.vue?vue&type=script&lang=js"

import "./ent_investigations.vue?vue&type=style&index=0&id=754dc600&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754dc600"]])

export default __exports__